export default __webpack_public_path__ + "fonts/AreaJPNormal-Bold.7fc30befbc8dba82713d388bd9ef2417.woff2";